export default __webpack_public_path__ + "static/media/messages_sel.4e14382a.svg";